/**
 * Created by Marsh on 2016.5.19.
 */

'use strict';

var appTypes = require('./appTypes');


exports.getTextAlign = function (horizontalAlign, verticalAlign) {
  var rsStyle = {
    position: 'absolute'
  };

  switch (horizontalAlign) {
    case 'HaLeft':
      rsStyle.left = '0px';
      switch (verticalAlign) {
        case 'VaTop':
          rsStyle.top = '0px';
          break;
        case 'VaMiddle':
          rsStyle.top = '50%';
          rsStyle.transform = 'translateY(-50%)';
          break;
        case 'VaBottom':
          rsStyle.bottom = '0px';
          break;
      }
      break;
    case 'HaCenter':
      rsStyle.left = '50%';
      switch (verticalAlign) {
        case 'VaTop':
          rsStyle.top = '0px';
          rsStyle.transform = 'translateX(-50%)';
          break;
        case 'VaMiddle':
          rsStyle.top = '50%';
          rsStyle.transform = 'translate(-50%,-50%)';
          break;
        case 'VaBottom':
          rsStyle.bottom = '0px';
          rsStyle.transform = 'translateX(-50%)';
          break;
      }
      break;
    case 'HaRight':
      rsStyle.right = '0px';
      switch (verticalAlign) {
        case 'VaTop':
          rsStyle.top = '0px';
          break;
        case 'VaMiddle':
          rsStyle.top = '50%';
          rsStyle.transform = 'translateY(-50%)';
          break;
        case 'VaBottom':
          rsStyle.bottom = '0px';
          break;
      }
      break;
  }

  return rsStyle;
};

exports.getTextHorizontalAlign = function (horizontalAlign) {
  var rsAlign;

  switch (horizontalAlign) {
    case 'HaLeft':
      rsAlign = 'left';
      break;
    case 'HaCenter':
      rsAlign = 'center';
      break;
    case 'HaRight':
      rsAlign = 'right';
      break;
    case '0':
      rsAlign = 'left';
      break;
    case '1':
      rsAlign = 'center';
      break;
    case '2':
      rsAlign = 'right';
      break;
  }
  return rsAlign;
};

exports.getFlexVerticalAlign = function (verticalAlign) {
  var rsAlign;

  switch (verticalAlign) {
    case 'VaTop':
      rsAlign = 'flex-start';
      break;
    case 'VaMiddle':
      rsAlign = 'center';
      break;
    case 'VaBottom':
      rsAlign = 'flex-end';
      break;
    case '0':
      rsAlign = 'flex-start';
      break;
    case '1':
      rsAlign = 'center';
      break;
    case '2':
      rsAlign = 'flex-end';
      break;
  }
  return rsAlign;
};

exports.getFlexHorizontalAlign = function (horizontalAlign) {
  var rsAlign;

  switch (horizontalAlign) {
    case 'HaLeft':
      rsAlign = 'flex-start';
      break;
    case 'HaCenter':
      rsAlign = 'center';
      break;
    case 'HaRight':
      rsAlign = 'flex-end';
      break;
  }
  return rsAlign;
};

/***
 * 获取通常情况下的文本组件的文本样式
 * 注意，这里生成的样式是附加到文字所属的容器上的
 * @author mengxiaojiang
 * @createDate 2016-6-6
 * @param props
 * @param isMultiLineText 是否为多行文本
 * @returns {{
 *              left: 0,
 *              top: 0,
 *              width: '100%',
 *              height: '100%',
 *              fontFamily: (cssKeyMap.textFontFamily|{name, type}),
 *              fontSize: (cssKeyMap.textSize|{name, type}),
 *              fontColor: (*|cssKeyMap.textColor|{name, type}),
 *              textAlign: *,
 *              fontWeight: *,
 *              textDecoration: *,
 *              fontStyle: *,
 *              lineHeight: string,
 *              paddingTop: (string|*|number),
 *              paddingBottom: (string|*|number),
 *              overflow : 'hidden',
 *              textOverflow : 'clip',
 *              position: 'absolute'
 *          }}
 */
exports.getNormalTextCSS = function (props, isMultiLineText) {
  var textStyles = props.textStyles;
  var fontFamily = props.textFontFamily;
  var bold = textStyles.fontWeight;
  var textDecoration = textStyles.textDecoration;
  var fontStyle = textStyles.fontStyle;
  var fontSize = props.textSize;
  var fontColor = props.textColor;
  var fontHortAlign = props.textAlign;
  var lineHeight = props.h + 'px';
  var vertAlign = props.textVAlign;
  var height = props.h;
  var paddingTop = props.paddingTop || 2;
  var paddingBottom = props.paddingBottom || 2;

  switch (fontHortAlign) {
    case appTypes.HoriAlign.CENTER:
      fontHortAlign = 'center';
      break;
    case appTypes.HoriAlign.LEFT:
      fontHortAlign = 'left';
      break;
    case appTypes.HoriAlign.RIGHT:
      fontHortAlign = 'right';
      break;
  }

  var CSS = {
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontColor: fontColor,
    textAlign: fontHortAlign,
    fontWeight: bold,
    textDecoration: textDecoration,
    fontStyle: fontStyle,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    overflow: 'hidden',
    textOverflow: 'clip',
    position: 'relative',
    verticalAlign: 'middle'
  };
  if (!isMultiLineText) {
    switch (vertAlign) {
      case appTypes.VertAlign.BOTTOM :
        lineHeight = (height - paddingBottom - paddingTop) * 2 - fontSize;
        break;
      case appTypes.VertAlign.TOP :
        lineHeight = fontSize + paddingTop;
        break;
      case appTypes.VertAlign.MIDDLE :
        lineHeight = height - paddingBottom - paddingTop;
        break;
    }

  } else {
    lineHeight = fontSize * (parseFloat(props.lineSpacingMultiple) + 0.33);//0.33为行距为1时的默认最小间距
    if (props.textWordWrap) {
      CSS.wordWrap = 'break-word';
    } else {
      CSS.whiteSpace = 'nowrap';
    }
  }
  lineHeight += 'px';
  CSS.lineHeight = lineHeight;
  return CSS;
};




// WEBPACK FOOTER //
// ./src/types/convertHelper.js